import { Application } from "./application";
import { ApplicationDTO } from "./applicationDTO";
import { inrDTO } from "./inrDTO";
import { PatientDTO } from "./patientDTO";



export class Patient implements PatientDTO {
  id: number;
  birthDate: string;
  category: string;
  cityName: string;
  email: string;
  gender: string;
  idNumber: string;
  idType: string;
  inrSet: inrDTO[];
  mrn: string;
  name: string;
  patientApplicationSet: ApplicationDTO[];
  patientApplication: Application;
  primaryMobileNo: string;
  secondaryMobileNo: string;
  files: any[];
  internalNotes: { date: string; content: string }[];



  constructor (data: PatientDTO) {

    this.id = data.id;
    this.birthDate = data.birthDate;
    this.category = data.category;
    this.cityName = data.cityName;
    this.email = data.email;
    this.gender = data.gender;
    this.idNumber = data.idNumber;
    this.idType = data.idType;
    this.inrSet = data.inrSet;
    this.mrn = data.mrn;
    this.name = data.name;
    this.patientApplicationSet = data.patientApplicationSet;
    this.patientApplication = Application.CreateFromData(this.patientApplicationSet);
    this.primaryMobileNo = data.primaryMobileNo;
    this.secondaryMobileNo = data.secondaryMobileNo;
    this.files = this.applicationDocumentSet;
    this.internalNotes = (data as any).internalNotes || [];
  }

  get applicationStatus() {
    return this.patientApplication.applicationStatus;
  }

  get appointmentDate() {
    return this.patientApplication.appointmentDate;
  }
  set appointmentDate(date: any) {
    this.patientApplication.appointmentDate = date;
  }

  get applicationDocumentSet() {
    this.patientApplication.applicationDocumentSet.forEach((element: any) => { element.type = element.type? element.type.toLowerCase() : ""  });
    return this.patientApplication.applicationDocumentSet || 'No Documents Found';
  }

  get inr() {
    return this.inrSet[0];
  }

  set inr(inr: inrDTO) {
    this.inrSet[0] = inr;
  }

}
